export const IS_CRM = (ENV_TAGS || []).indexOf("Crm") >= 0; //webpack.DefinePlugin

const cartConfig = {
  dateFormat: "MM/DD/YYYY",
  lblLineComments: "Comments",
  hideBuyer: false,
  lblBuyer: "Buyer",
  hideShipVia: false,
  lblShipVia: "Ship Method",
  lblPaymentTerms: "Payment Terms",
  hidePaymentTerms: false,
  hidePO: false,
  lblPO: "PO #",
  placeholderPO: "Your Purchase Order Number",
  hideDropShip: false,
  hideDropShipCRM: false,
  hideNote: false,
  lblNote: "Note",
  hideShipDt: false,
  lblShipDt: "Ship/Request Date",
  hideCancelDt: true,
  lblCancelDt: "Cancel Date",
  lblDiscount: "Discount",
  hideDiscount: false,
  hideLineDiscount: false,
  hidePromoStatus: false,
  hidePromoStatusCart: false,
  cartIcon: "fa-shopping-cart",
  cartTitle: "Cart",
  askQuestions: false,
  advancedCheckout: false,
  advancedCreateOrder: false,
  hideCartSummary: false,
  hideShippingNotes: true,
  hideAcceptTerms: true,
  lblAcceptTerms: "",
  hideShipComplete: true,
  lblShipComplete: "Ship Complete",
  hideRequestTermChange: true,
  lblRequestTermChange: "Request Term Change",
  ItemEditIcon: "fa-ellipsis-h",
  hideCopyItem: false,
  hideEditBilling: false,
  hideCreateLocation: false,
  hideVendor: true,
  preventDuplicateSKUs: false,
  hidePriceList: true,
  showSearchCountry: false,
  closeQuickViewOnSubmit: true,
  hideMoreOrderFields: false, // Used on cart-item-quick-view.htm
  includeComponentsInItemIndex: false,
  outOfStockText: "Out of Stock",
  useStockStatusTag: false,
  multiAddOptionsDefaultQty: true,
  allowSuggestionsOnScan: true,
  cartLoading(cart, session) {
    cart.cartTitle = session.isSalesManagementMode()
      ? "Order"
      : cartConfig.cartTitle;
    cart.acceptTermsMessage = `I have reviewed all the design previews placed on items in this cart. I own the rights or have permission to use the artwork in this cart. I agree to the ${session.clientName} Terms of Service.`;
  },
  itemSortOptions: {
    "-position": "Position: A to Z",
    position: "Position: Z to A",
    description: "Description: A to Z",
    price: "Price: Highest",
    "-price": "Price: Lowest",
    qtyPurchased: "Qty: Highest",
    "-qtyPurchased": "Qty: Lowest",
    productId: "Item #: Highest",
    status: "Status: A to Z",
    "-status": "Status: Z to A",
    shipOn: "Ship Date: Newest",
    "-shipOn": "Ship Date: Oldest",
  },
  newOrderOnCheckout: false,
  showPrintCart: false,
  hideContainerSummary: false,
  categoryRestrictions: false,
  vendorMinimums: false,
  vendorMinimumsSoftStop: false,
  showPriceCalculator: false,
  showAdditionalInfo: true,
  allowMultipleVendors: false,
  splitOnCheckout: false,
  ShowSalesManagementDiscountCodes: false,
  renderPersonalization: false,
  hideVendorScanOption: true,
  hideImportCSVFile: false,
  hidePasteItems: false,
  canChangeOrderDate: false,
  hideItemInputAdvancedSearch: true,
  hideProductLineAdvancedSearch: true,
  hideCategoryAdvancedSearch: true,
  routeAfterCloseLastSessionOrder: (cart, $session, $pageConfig) =>
    $session.isShowroom() && $pageConfig.isMobile() ? "home" : "orders",
  vendorScan: false,
  resendOrders: false,
  skuLockTimeout: 8888,
  changeQuantityTimeout: 1888,
  scheduleLoadTimeout: 18888,
  defaultShipDatePrev: false,
  getCartRequest: () => ({ DontIncludeProducts: 1 }),
  orderActivityTypes: [],
  mobileBreakpoint: "544",
  cartPlacedOnHoldWithReasonCodes: false,
  createUserOnCheckout: false,
  multiOrderAdd: false,
  useCaseQtyIncrement: false,
  showShippingRates: false,
  b2bItemUnavailableMessage: "ITEM NO LONGER AVAILABLE",
  crmItemUnavailableMessage: "ITEM NO LONGER AVAILABLE",
  playErrorSound: false, //IS_CRM,
  playSuccessSound: false, //IS_CRM,
  cartListAdvancedFilters: [
    {
      groupBy: "cartItemShipOn",
      title: "Ship Date",
      formatter: (t) => moment.utc(t.tagLabel).format("MM/DD/YYYY"),
    },
  ],
  //BL 09-23-22 changing these two defaults because we seem to be having to keep setting these as overrides to fix scanning/order entry issues
  // retainSearchWithNoScanResults: false,
  // scanDebounce: 350,
  retainSearchWithNoScanResults: true,
  scanDebounce: 1350,

  custOrdersInSession: (cart) =>
    cart.ordersInSession().filter((o) => o.customerID === cart.retailerId) ||
    [],
  allowManualItemEntry: (type) => false,
  //BL removing this default - it causes problems if they have a cancelDateDays setting of more than 120 days out - i think this should just be added to customer specific settings not default
  //maxCancelDaysAfterShip: 120, //https://emun1.monday.com/boards/333027351/views/4635648/pulses/4117042794
  useAptean(cart) {
    return false;
  },
  usePayfabric(cart) {
    return false;
  },
  useTokenex(cart) {
    return false;
  },
  useHostedPCI(cart) {
    return false;
  },
  useVersapay: false,
  useNmi: false,
  //production
  tokenExId: 4970065210223608,
// sandbox  
//tokenExId: 6262617667479887,
  tokenExOrigin: "http://localhost:8461",
};

export default cartConfig;
